import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { AlarmsEffectsModule } from './effects';
import { reducers } from './reducers';

export * from './reducers';
export * from './effects';
export * from './actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('alarms', reducers), AlarmsEffectsModule]
})
export class AlarmsStoreModule {}
